import { render } from "./ReportViewer.vue?vue&type=template&id=7797a52c&scoped=true"
import script from "./ReportViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportViewer.vue?vue&type=script&setup=true&lang=js"

import "./ReportViewer.vue?vue&type=style&index=0&id=7797a52c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7797a52c"],['__file',"src/core/report/ReportViewer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7797a52c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7797a52c', __exports__)) {
    console.log('reload')
    api.reload('7797a52c', __exports__)
  }
  
  module.hot.accept("./ReportViewer.vue?vue&type=template&id=7797a52c&scoped=true", () => {
    console.log('re-render')
    api.rerender('7797a52c', render)
  })

}


export default __exports__